import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaInvaliditaCivileEditComponent.vue?vue&type=template&id=4165f464"
import script from "./RsaSchedaRelazioneSanitariaInvaliditaCivileEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaInvaliditaCivileEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports